<template>
    <div class="grid grid-cols-3 gap-2">
        <div v-for="(file, index) in files" :key="index" class="border p-2 flex items-center overflow-hidden">
            <AloUploadInline :value="file.url" @input="update(file, $event)" />
        </div>
    </div>
</template>

<script>
import AloUploadInline from '@App/Vue/Alo/UploadInline.vue'

export default {
    components: { AloUploadInline },
    props: ['value', 'field'],
    data() {
        return {
            files: this.value || [{ url: '' }],
        }
    },
    watch: {
        files: {
            deep: true,
            handler(value) {
                this.$emit('input', this.files)
            },
        },
    },
    methods: {
        update(file, event) {
            file.url = event
            this.files.push({ url: '' })
        },
    },
}
</script>
